import { render, staticRenderFns } from "./tan_needGz_list_one_seven.vue?vue&type=template&id=e6c6574e&scoped=true"
import script from "./tan_needGz_list_one_seven.vue?vue&type=script&lang=js"
export * from "./tan_needGz_list_one_seven.vue?vue&type=script&lang=js"
import style0 from "./tan_needGz_list_one_seven.vue?vue&type=style&index=0&id=e6c6574e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c6574e",
  null
  
)

export default component.exports